import React, { PureComponent, Fragment } from "react";
import { PropTypes } from "prop-types";
import { Transition, Popup, Icon } from "semantic-ui-react";

class PCoIPString extends PureComponent {
  static propTypes = {
    publicIP: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      color: "orange"
    };
  }

  // -- RENDER -- //

  render() {
    const { publicIP } = this.props;
    const { color, node, popupCopy, visible, open } = this.state;

    return (
      <Fragment>
        <a href={"pcoip://" + publicIP} target="_self">
          <Icon
            className="external-link-icon"
            color={color}
            name="external"
            size="small"
          />
        </a>
      </Fragment>
    );
  }
}

export default PCoIPString;
